import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialLibModule } from '@app/material-lib.module';
import { AuthenticatedUserService } from '@ig-core/authentication/authenticated-user-service';
import { DataSourcingCallComponent } from './request-xdata-history-list/data-source.component';
import { DbDirectComponent } from './db-direct/db-viewer.component';

export const adminToolRoute: Route = {
  path: 'tools',
  canActivate: [AuthenticatedUserService],
  children: [
    { path: '', component: DataSourcingCallComponent },
    { path: 'dbdirect', component: DbDirectComponent }
    ]
};

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    MaterialLibModule,
    FormsModule,
    RouterModule,
    FlexLayoutModule,
    ReactiveFormsModule
  ],
  declarations: [ ], /* ReferenceCodeListComponent, */
  entryComponents: []
})
export class AdminToolModule { }
